import React from "react";
import { Container, HelperTitle, Title } from "./styles";
import { User, Home, Users, HelpCircle, Search } from "react-feather";
import { FaBuilding, FaLandmark, FaTractor, FaWarehouse } from "react-icons/fa";
import RelatoriosLogo from "../../Assets/relatorios.png";
import CeleiroLogo from "../../Assets/celeiro.png";

interface Props {
  type:
    | "PERFIL"
    | "FUNCIONÁRIOS"
    | "IMÓVEIS"
    | "PREFEITURAS"
    | "OPERAÇÕES"
    | "BENFEITORIAS"
    | "CARTÓRIOS"
    | "IMÓVEIS RURAIS"
    | "RELATÓRIOS"
    |"Pesquisar Guia de ITBI";
}

export function Header({ type }: Props) {
  function DefineIcons() {
    if (type == "PERFIL") {
      return <User size={"max(18px, 1.5vw)"} />;
    }
    if (type == "IMÓVEIS") {
      return <Home size={"max(18px, 1.5vw)"} />;
    }
    if (type == "IMÓVEIS RURAIS") {
      // return <FaTractor size={"max(18px, 1.5vw)"} />;
      return <img src={CeleiroLogo} style={{ width: "max(18px, 1.5vw)" }} />;
    }
    if (type == "FUNCIONÁRIOS") {
      return <Users size={"max(18px, 1.5vw)"} />;
    }
    if (type == "OPERAÇÕES") {
      return <HelpCircle size={"max(18px, 1.5vw)"} />;
    }
    if (type == "CARTÓRIOS") {
      return <FaBuilding size={"max(18px, 1.5vw)"} />;
    }
    if (type == "PREFEITURAS") {
      return <FaLandmark size={"max(18px, 1.5vw)"} />;
    }
    if (type == "BENFEITORIAS") {
      return <FaWarehouse size={"max(18px, 1.5vw)"} />;
    }
    if (type == "Pesquisar Guia de ITBI") {
      return <Search size={"max(18px, 1.5vw)"} />;
    }

    if (type == "RELATÓRIOS") {
      return <img src={RelatoriosLogo} style={{ width: "max(18px, 1.5vw)" }} />;
    }
  }

  return (
    <Container>
      <Title>
        {DefineIcons()}
        <HelperTitle> {type}</HelperTitle>
      </Title>
    </Container>
  );
}
